import { HIDE_THIRD_PARTY_POPUP } from '../types';

export default (state = true, action) => {
  switch (action.type) {
    case HIDE_THIRD_PARTY_POPUP:
      return action.payload
    default:
      return state;
  }
}